import { Incident } from "../../types"
import * as styles from "./styles"
import React, { useState } from "react"
import ReactSelect from "react-select"
import useIncidents from "hooks/use-incidents"

const incidents: Incident[] = useIncidents()

const reducer = (accumulator, currentValue) => {
  const { severity } = currentValue
  if (severity && !accumulator.some(a => a.value === severity.id)) {
    accumulator.push({
      value: severity.id,
      label: severity.name,
    })
  }
  return accumulator
}

const options = incidents.reduce(reducer, []).sort()

interface SelectProps {
  className?: string
  onChange: (option) => void
}

const customStyles = {
  option: provided => ({
    ...provided,
    ...styles.option,
  }),
  multiValue: provided => ({
    ...provided,
    ...styles.multiValue,
  }),
  multiValueLabel: provided => ({
    ...provided,
    ...styles.multiValueLabel,
  }),
  multiValueRemove: provided => ({
    ...provided,
    ...styles.multiValueRemove,
  }),
  noOptionsMessage: provided => ({
    ...provided,
    ...styles.noOptionsMessage,
  }),
  control: (provided, state) => ({
    ...provided,
    ...styles.control(state),
  }),
  placeholder: provided => ({
    ...provided,
    ...styles.placeholder,
  }),
  valueContainer: provided => ({
    ...provided,
    ...styles.valueContainer,
  }),
  indicatorSeparator: provided => ({
    ...provided,
    ...styles.indicatorSeparator,
  }),
}

export const Select: React.FC<SelectProps> = ({ className, onChange }) => {
  const [selectedOption, setSelectedOption] = useState(null)

  const handleChange = option => {
    setSelectedOption(option)
    onChange(option)
  }

  return (
    <ReactSelect
      className={className}
      defaultValue={selectedOption}
      onChange={handleChange}
      options={options}
      isMulti={true}
      placeholder="Filter By Incident ID..."
      styles={customStyles}
    />
  )
}
